import { Client, cacheExchange, fetchExchange, mapExchange } from "urql";

import { getAPIEndpoint, getLangCode } from ".";
import { AUTH_ERROR, language } from "./constants";
import { setShowRevalidateModal } from "../redux/slices/loginSlice";
import store from "../redux/store";

const getCsrfToken = () => {
  // Cypress (browser, but test-controlled)
  if (typeof window !== "undefined" && window.Cypress) {
    return "test-token";
  }

  // Node (SSR, scripts, etc.)
  if (typeof window === "undefined") {
    return process.env.CSRF_TOKEN;
  }

  // Real browser
  return window.__CSRF_TOKEN__;
};

export const client = new Client({
  url: getAPIEndpoint(),
  exchanges: [
    cacheExchange,
    mapExchange({
      onError(error) {
        const hasGqlAuthError =
          error.graphQLErrors && error.graphQLErrors.some((gqlError) => gqlError.message.includes(AUTH_ERROR));
        const hasNetworkAuthError = error.networkError && error.networkError.message.includes(AUTH_ERROR);
        if (hasGqlAuthError || hasNetworkAuthError) {
          store().dispatch(setShowRevalidateModal({ showRevalidateModal: true }));
        }
      },
    }),
    fetchExchange,
  ],
  fetchOptions: () => {
    const csrf = getCsrfToken();

    return {
      headers: {
        "content-language": language.codes[getLangCode()],
        ...(csrf ? { "x-csrf-token": csrf } : {}),
        "content-type": "application/json",
      },
      credentials: "include",
    };
  },
});
